import type { SerializedStyles } from "@emotion/react";
import { faShippingFast } from "@fortawesome/pro-regular-svg-icons";
import type { ReactNode } from "react";

import { Arrange, Typography } from "@aviary";
import { MeterBar } from "@shared/components/MeterBar/MeterBar";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./FreeShippingMeter.styles";

interface Props {
  subtotal?: number;
  freeShippingHelpText: ReactNode;
  fontType?: "footnote" | "body";
  children?: ReactNode;
  containerStyles?: SerializedStyles;
  meterWrapperStyles?: SerializedStyles;
  freeShippingThreshold: number;
}

const FreeShippingMeter = ({
  freeShippingHelpText,
  children,
  containerStyles,
  meterWrapperStyles,
  freeShippingThreshold,
  subtotal = 0,
  fontType = "footnote",
}: Props) => {
  return (
    <Arrange spacing="xsmall" isVertical isFullWidth justify="center" css={containerStyles}>
      <Typography type={fontType} css={styles.centeredText}>
        {freeShippingHelpText}
      </Typography>
      <Arrange
        spacing="xsmall"
        justify="center"
        alignment="center"
        isFullWidth
        isWrapped={false}
        css={[styles.meterWrapper, meterWrapperStyles]}
      >
        <MeterBar
          min={0}
          max={freeShippingThreshold}
          value={subtotal}
          title="$"
          css={styles.meter}
          data-testid="shipping-meter-bar"
        />
        <FontAwesomeIcon icon={faShippingFast} size="sm" css={styles.icon} />
      </Arrange>
      {children}
    </Arrange>
  );
};

export { FreeShippingMeter };
